import { render } from "./List.vue?vue&type=template&id=ed164faa"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=ed164faa&lang=scss"
script.render = render

export default script